import React from 'react';
import {
  NavItem,
  Nav,
  Col,
  Tab,
  Row,
} from 'react-bootstrap';
import { browserHistory } from 'react-router';
import TourHotelManageTab from './TourHotelManageTab';

class TourHotelTabViewer extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(detailTab) {
    const url = `/tours/${this.props.tour.id}/hotels/4`;
    console.log(`tab selected ${detailTab} but we always use 4`);
    browserHistory.push(url);
  }

  render() {
    const activeKey = this.props.detailTab ? this.props.detailTab : '4';
    return (
      <div className="col-sm-12 planner">
        <Tab.Container
          id="tabs-with-dropdown"
          activeKey={activeKey}
          onSelect={this.handleSelect}
        >
          <Row className="clearfix">
            <Col sm={12}>
              <Nav bsStyle="tabs">
                <NavItem eventKey="4" />
              </Nav>
            </Col>
            <Col sm={12}>
              <Tab.Content animation>
                <Tab.Pane eventKey="4">
                  <TourHotelManageTab
                    tour={this.props.tour}
                    detail={this.props.detailSelect}
                    isTourManager={this.props.isTourManager}
                    readOnly={this.props.readOnly}
                  />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    );
  }
}

export default TourHotelTabViewer;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHotelTabViewer.js